import { downloadClient } from 'utils/downloadChattt';
import { useOrgValue } from './business/system/useOrg';
import { useState } from 'react';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

export const useDownloadClient = () => {
  const orgValue = useOrgValue();
  const { t } = useTranslate();
  const [loading, setLoading] = useState(false);

  return async () => {
    try {
      if (loading) return;
      setLoading(true);
      await downloadClient(orgValue?.orgChannel);
    } catch (err) {
      message.error(t('ViewsChat.下载失败，请稍后再试'));
    } finally {
      setLoading(false);
    }
  };
};
